__turbopack_context__.v({
  "controls": "EditOfficeHoursFormControls-module-scss-module__B2aHuG__controls",
  "mobileCloseButton": "EditOfficeHoursFormControls-module-scss-module__B2aHuG__mobileCloseButton",
  "primaryButton": "EditOfficeHoursFormControls-module-scss-module__B2aHuG__primaryButton",
  "root": "EditOfficeHoursFormControls-module-scss-module__B2aHuG__root",
  "secondaryButton": "EditOfficeHoursFormControls-module-scss-module__B2aHuG__secondaryButton",
  "title": "EditOfficeHoursFormControls-module-scss-module__B2aHuG__title",
});
